import { SubscriptionType } from '$store/models';
import {
  SUBSCRIPTION_ADULT,
  SUBSCRIPTION_AUTHOR,
  SUBSCRIPTION_BASIC,
  SUBSCRIPTION_MEDIA,
  SUBSCRIPTIONS,
} from '$shared/constants/pages';

// Страница покупки подписки по её типу.
export function subscriptionPayRoute(
  type: SubscriptionType,
  authorId?: number,
): { name: string; params: Record<string, any> } {
  switch (type) {
    case SubscriptionType.Author:
      return authorId
        ? { name: SUBSCRIPTION_AUTHOR, params: { authorId } }
        : { name: SUBSCRIPTIONS, params: {} };
    case SubscriptionType.Adult:
      return { name: SUBSCRIPTION_ADULT, params: {} };
    case SubscriptionType.Media:
      return { name: SUBSCRIPTION_MEDIA, params: {} };
    case SubscriptionType.Basic:
      return { name: SUBSCRIPTION_BASIC, params: {} };
    default:
      return { name: SUBSCRIPTIONS, params: {} };
  }
}
